/* ============================================================
   Environment seam. Two envs for now:
   · local  — `npm run dev`          → VITE_MOCK=1, no backend needed
   · dev    — deployed web-dev.miya.fm → `npm run build:dev`, real API
   Real API = mia-data (webintegration.md):
     protected endpoints under /client/*, public share under /share/*.
   ============================================================ */

export const ENV = {
  /* mia-data base URL. '/api' = same-origin reverse proxy;
     'https://mia-data-dev.miya.fm' = direct cross-origin (CORS). */
  API: import.meta.env.VITE_API_BASE || '/api',

  /* the agent harness (miya_agent, protocol 2.x) that /listen talks to — auth-on:
     every call carries the mia-data access token. Cross-origin; the service allows it. */
  AGENT: import.meta.env.VITE_AGENT_BASE || 'https://mia-agent-dev.miya.fm',
  /* the persona /listen asks for; 422 (unknown here) falls back to the deployment default */
  AGENT_PERSONA:
    import.meta.env.VITE_AGENT_PERSONA ||
    'miya' /* the merged persona (harness dev 2026-09-16): the booth and the studio in one room */,

  /* mock mode: full front-end simulation, zero backend */
  MOCK: import.meta.env.VITE_MOCK === '1',

  /* Google OAuth(2026-08-29 起主用:X 官方应用被封,X 登录暂停——契约 §1)。
     同一套同页跳转 + PKCE;client id 是 Web 客户端专用(与 PC 端不同),
     回调页必须在 Google 控制台的 Web 客户端里精确登记。 */
  GOOGLE_CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID || '',
  GOOGLE_REDIRECT_URI:
    import.meta.env.VITE_GOOGLE_REDIRECT_URI ||
    (typeof location !== 'undefined' ? location.origin + '/google-callback' : ''),

  /* X OAuth —— 暂停但保留(契约留了 /client/auth/x/login 供恢复)。 */
  X_CLIENT_ID: import.meta.env.VITE_X_CLIENT_ID || '',
  X_REDIRECT_URI:
    import.meta.env.VITE_X_REDIRECT_URI || (typeof location !== 'undefined' ? location.origin + '/x-callback' : ''),

  /* feature switch: sharing to X (the owner's Post to X — composer AND
     diss handoff). VITE_SHARE_X=0 turns it off for that environment;
     the button then turns into its own "not open yet". Default ON. */
  SHARE_X: import.meta.env.VITE_SHARE_X !== '0',

  /* how this site's THE ASK looks (owner 2026-09-09, the mock station): 'google' = Continue with Google; 'token' = no
     door, her line says to ask the team for a pass link. The pass link itself (?token=<mia-data access token>) is
     accepted in EVERY mode — a second door the team can hand to a tester. */
  AUTH: import.meta.env.VITE_AUTH === 'token' ? 'token' : 'google',
  /* the pass link (?token=<access token>) as a door: on for dev/test stations, VITE_PASS_LINK=0 on production —
     a bearer in a URL is a door for testers, not for the public (owner 2026-09-11) */
  PASS_LINK: import.meta.env.VITE_PASS_LINK !== '0',

  /* feature switch: invite-gated sign-up. 1 = the ask offers an invite-code
     field whenever the SERVER's gate is on (probed via /client/invites/check
     — the server stays the source of truth); 0 = never show the field, and
     a server-side 403 still gets a graceful line. Flip to 0 and redeploy
     the day codes retire. */
  INVITE: import.meta.env.VITE_INVITE !== '0',

  /* 神策上报地址(owner 2026-08-28:线上换 project=miya,开发不变)。
     不填走 track.js 里的 acestudio 默认——本地/dev 零配置照旧。 */
  SA_URL: import.meta.env.VITE_SA_URL || '',
};
